export const en = {
    'add-minus-phrases': 'Add negative keywords',
    'add-phrases': 'Add keywords',
    'add-phrases-to-group': 'Add to ad group',
    'add-to-start': 'Add to Base',
    'chosen-phrases': 'Selected keywords',
    'chosen-phrases-empty-header': 'Add selected to the ad group',
    'chosen-phrases-empty-text': 'Here you will see a list of keywords which you can add to your ad group',
    'minus-phrases': 'Negative keywords',
    'minus-phrases-empty-header': 'Add selected to the ad group',
    'minus-phrases-empty-text': 'Here you will see a list of negative keywords that you can add to your ad group',
    'minus-words': 'Negative keywords',
    'phrase-selection': 'Keyword planner',
    phrases: 'Keywords',
    'phrases-input-placeholder': 'Enter queries separated with commas, or use the ( | ) operator',
    'search-also-phrases-empty-header': 'No base queries specified',
    'search-also-phrases-empty-text':
        'Here you will see queries similar to the base queries selected in the left column',
    'search-also-phrases-not-exist-header': 'No similar queries',
    'search-also-phrases-not-exist-text': 'Change the base query in the left column',
    'searched-also': 'Similar',
    'searched-also-phrases': 'Similar queries',
    'searched-with': 'Nested',
    'shows-per-month': 'Impressions per month',
    'similar-phrases-empty-header': 'No base queries specified',
    'similar-phrases-empty-text':
        'Here you will see nested queries similar to the base queries selected in the left column',
    'similar-phrases-not-exist-header': 'No nested queries',
    'similar-phrases-not-exist-text': 'Change the base query in the left column',
    'start-phrases': 'Base queries',
    'start-phrases-empty-header': 'No queries specified',
    'start-phrases-empty-text': 'Enter the queries comma-separated'
};
